module.exports = __webpack_public_path__ + "img/logo2.9be9c436.png";